import React, { useContext, useEffect, useRef } from "react";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";
import Form from "./Form";

const doesNothing = () => {};

const StyledDiv = styled.div``;

const MayRequireForm = ({ onApply = null, children }) =>
  typeof onApply === "function" ? (
    <Form onSubmit={onApply}>{children}</Form>
  ) : children ;

const Modal = ({
  title,
  subTitle = undefined,
  content = () => null,
  onClose = doesNothing,
  closeLabel = "CLOSE",
  onApply = null,
  applyLabel = "OK",
  applyDisabled = false,
  superIcon = undefined,
  superIconJSX = undefined,
  large = false,
  footerMessage = null,
  id = undefined,
  wontClose = false,
  className = undefined,
  noPadding = false,
}) => {
  const modal = useRef();
  const actions = useContext(ActionsContext);
  const closeModal = (target = modal.current) => {
    actions.send('close-modal');
    $(target).modal("hide");
    $(target).data("modal", null);
    $(".modal-backdrop").remove();
    $(document.body).removeClass('modal-open')
    $(document.body).css({'padding-right':'0px'})
  };
  useEffect(() => {
    const target = modal.current;
    if (target === null) {
      return undefined;
    }
    actions.send('open-modal');
    $(modal.current).modal("show").on("hidden.bs.modal", () => {
      closeModal();
      onClose();
    });
  }, [modal]);

  useEffect(() => {
    return () => {
      closeModal();
    };
  }, []);

  const icon = superIconJSX ? (
    <div className="margin-r-15"> {superIconJSX} </div>
  ) : superIcon ? (
    <div className="text-center">
      <i className="material-icons font-size-80">{superIcon}</i>
    </div>
  ) : null;
  
  return (
    <StyledDiv
      className={`modal fade${className ? ` ${className}` : ""}`}
      role="dialog"
      ref={modal}
      id={id}
      data-backdrop={wontClose ? "" : "static"}
      data-keyboard={wontClose ? "" : "false"}
    >
      <div
        className={`modal-dialog ${large === true ? "modal-lg" : ""}`}
        role="document"
      >
        <MayRequireForm onApply={onApply}>
          <div className="modal-content">
            {title && (
              <div className="modal-header">
                {icon}
                <h4 className="modal-title">{title}</h4>
                {subTitle === undefined ? null : (
                  <p>
                    <span className="subtitle">{subTitle}</span>
                  </p>
                )}
              </div>
            )}
            <div className={`modal-body${noPadding ? " no-padding" : ""}`}>
              {content()}
            </div>
            <div className="modal-footer">
              {footerMessage}
              {onApply === null ? null : (
                <button
                  type="submit"
                  className="btn btn-link waves-effect"
                  disabled={applyDisabled}
                >
                  {applyLabel}
                </button>
              )}
              {closeLabel === null ? null : (
                <button
                  type="button"
                  className="btn btn-link waves-effect"
                  data-dismiss="modal"
                >
                  {closeLabel}
                </button>
              )}
            </div>
          </div>
        </MayRequireForm>
      </div>
    </StyledDiv>
  );
};
export default Modal;
